"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultAppId = exports.version = void 0;

var _react = _interopRequireDefault(require("react"));

// import
// definition
var version = 'v12.0';
exports.version = version;
var defaultAppId = '286359492558905';
exports.defaultAppId = defaultAppId;

var _default = /*#__PURE__*/_react["default"].createContext({
  fb: null,
  appId: defaultAppId,
  version: version,
  isLoginEnabled: false
});

exports["default"] = _default;